// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1hHdc","alert":"SettungsInbox_alert__16_YU"};